import { Resource, ResourceProps } from 'react-admin';
import { BiAward, BiSolidCoupon, BiStats, BiSupport } from 'react-icons/bi';
import { CgOrganisation } from 'react-icons/cg';
import {
	FaBabyCarriage,
	FaCalendar,
	FaCog,
	FaFlask,
	FaCommentDots,
	FaHandshake,
	FaHeadphones,
	FaPodcast,
	FaHistory,
	FaLayerGroup,
	FaMicrophone,
	FaMicrophoneAlt,
	FaNewspaper,
	FaTag,
	FaUsers,
	FaVideo,
} from 'react-icons/fa';
import { GiTeacher, GiWeightLiftingUp } from 'react-icons/gi';
import { MdEmail, MdOutlineVideoLibrary, MdQuiz, MdSchool } from 'react-icons/md';
import './App.css';
import ActivityLogsList from './components/ActivityLogs/ActivityLogsList';
import AnonymousFeedbackList from './components/AnonymousFeedback/AnonymousFeedbackList';
import OnboardingNotesList from './components/OnboardingNotes/OnboardingNotesList';
import ExpertRankingList from './components/ExpertRanking/ExpertRankingList';
import InterventionsList from './components/Interventions/InterventionsList';
import CompanyCreate from './components/Company/CompanyCreate';
import CompanyEdit from './components/Company/CompanyEdit';
import CompanyList from './components/Company/CompanyList';
import ExpertEdit from './components/Expert/ExpertEdit';
import ExpertList from './components/Expert/ExpertList';
import MeetingCreate from './components/Meeting/MeetingCreate';
import MeetingEdit from './components/Meeting/MeetingEdit';
import MeetingList from './components/Meeting/MeetingList';
import ServiceEdit from './components/Service/ServiceEdit';
import ServiceList from './components/Service/ServiceList';

import ArticleCreate from './components/Article/ArticleCreate';
import ArticleEdit from './components/Article/ArticleEdit';
import ListArticles from './components/Article/ListArticles';
import BlogCreate from './components/Blog/BlogCreate';
import BlogEdit from './components/Blog/BlogEdit';
import BlogList from './components/Blog/BlogList';
import CategoryCreate from './components/Category/CategoryCreate';
import CategoryEdit from './components/Category/CategoryEdit';
import CategoryList from './components/Category/CategoryList';
import ExpertCreate from './components/Expert/ExpertCreate';
import CreateNewbornInvitation from './components/Invitation/CreateNewbornInvitation';
import InvitationsList from './components/Invitation/InvitationsList';
import LectureCategoryCreate from './components/Lecture/LectureCategory/LectureCategoryCreate';
import LectureCategoryEdit from './components/Lecture/LectureCategory/LectureCategoryEdit';
import LectureCategoryList from './components/Lecture/LectureCategory/LectureCategoryList';
import LectureCreate from './components/Lecture/LectureCreate';
import LectureEdit from './components/Lecture/LectureEdit';
import LectureList from './components/Lecture/LectureList';
import MediaCategoryCreate from './components/MediaCategory/MediaCategoryCreate';
import MediaCategoryEdit from './components/MediaCategory/MediaCategoryEdit';
import MediaCategoryList from './components/MediaCategory/MediaCategoryList';
import MediaLinkCreate from './components/MediaLink/MediaLinkCreate';
import MediaLinkEdit from './components/MediaLink/MediaLinkEdit';
import MediaLinkList from './components/MediaLink/MediaLinkList';
import PodcastCreate from './components/Podcast/PodcastCreate';
import PodcastEdit from './components/Podcast/PodcastEdit';
import PodcastList from './components/Podcast/PodcastList';
import MeetingShow from './components/Meeting/MeetingShow';
import MemberEdit from './components/Member/MemberEdit';
import MemberList from './components/Member/MemberList';
import MemberShow from './components/Member/MemberShow';
import PrivateSessionsList from './components/PrivateSessions/PrivateSessionsList';
import PrivateServicePackagesList from './components/PrivateServicePackages/PrivateServicePackagesList';
import ReviewCreate from './components/Review/ReviewCreate';
import ReviewEdit from './components/Review/ReviewEdit';
import ReviewList from './components/Review/ReviewList';
import SectionEdit from './components/Section/SectionEdit';
import SectionList from './components/Section/SectionList';
import ServiceCreate from './components/Service/ServiceCreate';
import TagCreate from './components/Tag/TagCreate';
import TagEdit from './components/Tag/TagEdit';
import TagList from './components/Tag/TagList';
import DatingEventCreate from './components/DatingEvent/DatingEventCreate';
import DatingEventEdit from './components/DatingEvent/DatingEventEdit';
import DatingEventList from './components/DatingEvent/DatingEventList';
import DatingEventShow from './components/DatingEvent/DatingEventShow';
import ListAiSearch from './components/aisearch/ListAiSearch';
import VodCreate from './components/Vod/VodCreate';
import VodEdit from './components/Vod/VodEdit';
import VodList from './components/Vod/VodList';
import { ROLE } from './providers/auth.types';

import CompanyShow from './components/Company/CompanyShow';
import CouponCreate from './components/Coupon/CouponCreate';
import CouponEdit from './components/Coupon/CouponEdit';
import CouponList from './components/Coupon/CouponList';
import CreatePrivateSession from './components/PrivateSessions/Dialogs/CreateSessionDialog';
import MonthlySessionEdit from './components/PrivateSessions/MonthlySessions/MonthlySessionsEdit';
import MonthlySessionsStats from './components/PrivateSessions/MonthlySessions/MonthlySessionsStats';
import PrizeCreate from './components/Prize/PrizeCreate';
import PrizeEdit from './components/Prize/PrizeEdit';
import PrizeList from './components/Prize/PrizeList';
import ProactiveItemCreate from './components/Proactive/ProactiveItemCreate';
import ProactiveItemEdit from './components/Proactive/ProactiveItemEdit';
import ProactiveItemList from './components/Proactive/ProactiveItemList';
import SettingCreate from './components/Setting/SettingCreate';
import SettingEdit from './components/Setting/SettingEdit';
import SettingList from './components/Setting/SettingList';
import TrialUsersCreate from './components/Setting/TrialUsers/TrialUsersCreate';
import TrialUsersList from './components/Setting/TrialUsers/TrialUsersList';
import MemberLead from './components/Setting/MembersLeads/MemberLead';
import CouponShow from './components/Coupon/CouponShow';
import EmailGroupList from './components/EmailGroup/EmailGroupList';
import EmailGroupEdit from './components/EmailGroup/EmailGroupEdit';
import EmailGroupCreate from './components/EmailGroup/EmailGroupCreate';
import SurveyQuestionList from './components/SurveyQuestion/SurveyQuestionList';
import SurveyQuestionEdit from './components/SurveyQuestion/SurveyQuestionEdit';
import SurveyQuestionCreate from './components/SurveyQuestion/SurveyQuestionCreate';
import CourseList from './components/Inputs/Learning/CourseList';
import CourseEdit from './components/Inputs/Learning/CourseEdit';
import CourseCreate from './components/Inputs/Learning/CourseCreate';
import PlanList from './components/Plan/PlanList';
import PlanEdit from './components/Plan/PlanEdit';
import PlanCreate from './components/Plan/PlanCreate';
import DatingEventCouponList from './components/DatingEventCoupon/DatingEventCouponList';
import DatingEventCouponEdit from './components/DatingEventCoupon/DatingEventCouponEdit';
import DatingEventCouponCreate from './components/DatingEventCoupon/DatingEventCouponCreate';
import DatingEventCouponShow from './components/DatingEventCoupon/DatingEventCouponShow';
import LifestyleAreaList from './components/lifestyleareas/LifestyleAreaList';
import LifestyleAreaEdit from './components/lifestyleareas/LifestyleAreaEdit';
import LifestyleAreaCreate from './components/lifestyleareas/LifestyleAreaCreate';
import AiPrizeList from './components/AiPrize/AiPrizeList';
import AiPrizeEdit from './components/AiPrize/AiPrizeEdit';
import AiPrizeCreate from './components/AiPrize/AiPrizeCreate';
import PermissionsList from './components/Permissions/PermissionsList';
import { FaShieldAlt, FaStar } from 'react-icons/fa';

const Resources = (permissions: any) => {
	const resources: {
		label: string;
		name: string;
		icon?: ResourceProps['icon'];
		list?: ResourceProps['list'];
		create?: ResourceProps['create'];
		edit?: ResourceProps['edit'];
		show?: ResourceProps['show'];
		onlyAvailableTo?: ROLE[];
	}[] = [
		{
			label: 'חברות',
			icon: CgOrganisation,
			name: 'company',
			list: CompanyList,
			show: CompanyShow,
			create: CompanyCreate,
			edit: ['superadmin', 'business-admin', 'admin'].includes(permissions) ? CompanyEdit : undefined,
			onlyAvailableTo: ['business-admin', 'admin', 'superadmin'],
		},
		{
			label: 'לוג פעילות',
			icon: FaHistory,
			name: 'activity-logs',
			list: ActivityLogsList,
			onlyAvailableTo: ['admin', 'superadmin'],
		},
		{
			label: 'פניות אנונימיות',
			icon: FaCommentDots,
			name: 'anonymous-feedback',
			list: AnonymousFeedbackList,
			onlyAvailableTo: ['admin', 'superadmin'],
		},
		{
			label: 'שיתופים מהאונבורדינג',
			icon: FaCommentDots,
			name: 'member-notes',
			list: OnboardingNotesList,
			onlyAvailableTo: ['admin', 'superadmin', 'expert-manager'],
		},
		{
			label: 'התערבויות פרואקטיביות',
			icon: FaHandshake,
			name: 'interventions',
			list: InterventionsList,
			onlyAvailableTo: ['admin', 'superadmin'],
		},
		{
			label: 'חבילות סדרות',
			icon: FaLayerGroup,
			name: 'private-service-packages',
			list: PrivateServicePackagesList,
			onlyAvailableTo: ['editor', 'admin', 'superadmin'],
		},
		{
			label: 'אירועי דייטינג ',
			icon: FaFlask,
			name: 'dating-events',
			list: DatingEventList,
			create: DatingEventCreate,
			edit: DatingEventEdit,
			show: DatingEventShow,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},

		{
			label:' קופונים לאירועי דייטינג ',
			icon: FaFlask,
			name: 'events-coupons',
			list: DatingEventCouponList,
			create: DatingEventCouponCreate,
			edit: DatingEventCouponEdit,
			show: DatingEventCouponShow,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		
		{
			label: 'קטגוריות VOD',
			icon: MdOutlineVideoLibrary,
			name: 'vod/categories',
			list: MediaCategoryList,
			edit: MediaCategoryEdit,
			create: MediaCategoryCreate,
			onlyAvailableTo: ['editor', 'expert-manager', 'admin', 'superadmin'],
		},
		{
			label: 'משובים',
			name: 'review',
			icon: () => <FaLayerGroup />,
			list: ReviewList,
			edit: ReviewEdit,
			create: ReviewCreate,
			onlyAvailableTo: ['admin', 'superadmin'],
		},

		{
			label: 'מומחים',
			icon: BiSupport,
			name: 'instructor',
			list: ExpertList,
			edit: ExpertEdit,
			create: ExpertCreate,
			// GH-724/735: 'expert-manager' (תמיכה טכנית) + 'business-admin' (מנהלת עסקית) edit experts
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'business-admin', 'expert-manager'],
		},
		{
			label: 'מומחים',
			icon: BiSupport,
			name: 'instructor/allin/experts',
			list: ExpertList,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'business-admin', 'expert-manager'],
		},
		{
			// GH-749 — pick experts for external events (ratings / lectures / popularity). Read-only.
			label: 'מאגר מומחים לאירועים',
			icon: FaStar,
			name: 'expert-ranking',
			list: ExpertRankingList,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'business-admin', 'expert-manager'],
		},
		{
			label: 'מטפלים',
			icon: BiSupport,
			name: 'instructor/allin/safe-space',
			list: ExpertList,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'business-admin', 'expert-manager'],
		},
		{
			label: 'קטגוריות מומחים',
			icon: FaLayerGroup,
			name: 'instructor-category',
			list: CategoryList,
			edit: CategoryEdit,
			create: CategoryCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'expert-manager'],
		},
		{
			label: 'בנק הרצאות',
			icon: MdSchool,
			name: 'service',
			list: ServiceList,
			edit: ServiceEdit,
			create: ServiceCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'business-admin', 'expert-manager'],
		},
		{
			label: 'הרצאות וסדנאות',
			icon: FaCalendar,
			name: 'meeting',
			list: MeetingList,
			edit: MeetingEdit,
			create: MeetingCreate,
			show: MeetingShow,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'group-sessions-viewer', 'business-admin', 'expert-manager'],
		},
		{
			label: 'VOD',
			icon: FaVideo,
			name: 'vod',
			list: VodList,
			edit: VodEdit,
			create: VodCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'expert-manager'],
		},
		{
			label: 'כתבות',
			icon: FaNewspaper,
			name: 'article',
			list: ListArticles,
			edit: ArticleEdit,
			create: ArticleCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'בלוג',
			icon: FaNewspaper,
			name: 'blog',
			list: BlogList,
			edit: BlogEdit,
			create: BlogCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},

		{
			label: 'תוכניות',
			icon: FaCalendar,
			name: 'ai-program',
			list: PlanList,
			edit: PlanEdit,
			create: PlanCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},

		{
			label: 'פרסי ai',
			icon: FaCalendar,
			name: 'ai-program-prize',
			list: AiPrizeList,
			edit: AiPrizeEdit,
			create: AiPrizeCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},

		{
			label: 'חיפושים',
			icon: FaNewspaper,
			name: 'member/get-searches',
			list: ListAiSearch,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'מתחמי לייף סטייל',
			icon: FaNewspaper,
			name: 'lifestyle-area/all',
			list: LifestyleAreaList,
			edit: LifestyleAreaEdit,
			create: LifestyleAreaCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'פודקאסטים',
			icon: FaPodcast,
			name: 'podcasts',
			list: PodcastList,
			edit: PodcastEdit,
			create: PodcastCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'פודקסטים ועוד',
			icon: FaHeadphones,
			name: 'media-links',
			list: MediaLinkList,
			edit: MediaLinkEdit,
			create: MediaLinkCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'הרצאות',
			icon: FaMicrophone,
			name: 'lecture',
			list: LectureList,
			edit: LectureEdit,
			create: LectureCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'business-admin'],
		},
		{
			label: 'קורסים',
			icon: GiTeacher,
			name: 'learning/course',
			list: CourseList,
			edit: CourseEdit,
			create: CourseCreate,
		},
		{
			label: 'קטגוריות הרצאות',
			icon: FaMicrophoneAlt,
			name: 'lecture/category',
			list: LectureCategoryList,
			edit: LectureCategoryEdit,
			create: LectureCategoryCreate,
			onlyAvailableTo: ['admin', 'editor', 'superadmin', 'business-admin'],
		},
		{
			label: 'בוסטים',
			icon: GiWeightLiftingUp,
			name: 'proactive/item',
			list: ProactiveItemList,
			create: ProactiveItemCreate,
			edit: ProactiveItemEdit,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'קטגוריות בוסטים',
			icon: GiWeightLiftingUp,
			name: 'proactive/item/category',
		},
		{
			label: 'פרסים',
			icon: BiAward,
			name: 'prize',
			list: PrizeList,
			create: PrizeCreate,
			edit: PrizeEdit,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		
		{
			label: 'תחומי עניין',
			icon: FaTag,
			name: 'tag/all',
			list: TagList,
			create: TagCreate,
			edit: TagEdit,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'קופונים',
			icon: BiSolidCoupon,
			name: 'coupon',
			list: CouponList,
			create: CouponCreate,
			edit: CouponEdit,
			show: CouponShow,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'מנויי לידה',
			name: 'invitation',
			icon: () => <FaBabyCarriage color="#D6ACAC" />,
			list: InvitationsList,
			create: CreateNewbornInvitation,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},
		{
			label: 'מתחמים',
			name: 'section',
			icon: FaLayerGroup,
			list: SectionList,
			edit: SectionEdit,
			onlyAvailableTo: ['admin', 'editor', 'superadmin'],
		},

		{
			label: 'משתמשים',
			icon: FaUsers,
			name: 'member',
			list: MemberList,
			edit: MemberEdit,
			show: MemberShow,
			onlyAvailableTo: ['superadmin', 'admin', 'editor', 'business-admin'],
		},
		{
			label: 'מפגשים פרטניים',
			icon: FaHandshake,
			name: 'instructor/private_services/sessions',
			list: PrivateSessionsList,
			create: CreatePrivateSession,
			onlyAvailableTo: ['superadmin', 'admin', 'editor'],
		},
		{
			label: 'סיכום מפגשי מומחים',
			icon: BiStats,
			name: 'instructor/sessions/stats/by_host',
			list: MonthlySessionsStats,
			edit: MonthlySessionEdit,
			onlyAvailableTo: ['admin', 'superadmin'],
		},
		{
			label: 'שאלון Wellbeing',
			icon: MdQuiz,
			name: 'survey/question',
			list: SurveyQuestionList,
			edit: SurveyQuestionEdit,
			create: SurveyQuestionCreate,

			onlyAvailableTo: ['admin', 'superadmin'],
		},
		{
			label: 'הגדרות אפליקציה',
			icon: FaCog,
			name: 'setting',
			list: SettingList,
			create: SettingCreate,
			edit: SettingEdit,
			onlyAvailableTo: ['superadmin'],
		},
		{
			label: 'רשימות תפוצה',
			icon: MdEmail,
			name: 'member/email-group',
			create: EmailGroupCreate,
			list: EmailGroupList,
			edit: EmailGroupEdit,
			// create: TrialUsersCreate,
			onlyAvailableTo: ['admin', 'superadmin'],
		},
		{
			label: 'מנוי התנסות',
			icon: FaFlask,
			name: 'setting/trial',
			list: TrialUsersList,
			create: TrialUsersCreate,
			onlyAvailableTo: ['admin', 'superadmin'],
		},
		{
			label: 'לידים של מינויים',
			icon: FaFlask,
			name: 'member-leads',
			list: MemberLead,
			create: TrialUsersCreate,
			onlyAvailableTo: ['admin', 'superadmin'],
		},
		{
			label: 'הרשאות',
			icon: FaShieldAlt,
			name: 'admin/permissions',
			list: PermissionsList,
			onlyAvailableTo: ['superadmin'],
		},


	];
console.log(resources);
	return resources
		.filter((resource) => !resource.onlyAvailableTo || resource.onlyAvailableTo.includes(permissions))
		.map((resource) => <Resource key={resource.name} {...resource} options={{ label: resource?.label }} />);
};

export default Resources;
